export const VIDEOS = [
  {
    href: 'https://youtu.be/WFikbJdBBnk',
    thumb: 'https://i.ytimg.com/vi/WFikbJdBBnk/hqdefault.jpg',
    alt: 'Marriage possibility in horoscope',
    duration: '12:34',
    chip: 'Marriage',
    title: 'Can you see the possibility of marriage in your own horoscope?',
    anim: 'mg-al',
    delay: '.10s',
  },
  {
    href: 'https://youtu.be/-P6l4phA-Uo',
    thumb: 'https://i.ytimg.com/vi/-P6l4phA-Uo/hqdefault.jpg',
    alt: 'Ketu Phaladesh Leo Ascendant',
    duration: '18:47',
    chip: 'Kundli',
    title: "Ketu's Phaladesh in Leo Ascendant",
    anim: 'mg-au',
    delay: '.18s',
  },
  {
    href: 'https://youtu.be/B_KUEAARh6o',
    thumb: 'https://i.ytimg.com/vi/B_KUEAARh6o/hqdefault.jpg',
    alt: 'Basic principles of astrological predictions',
    duration: '24:15',
    chip: 'Basics',
    title: 'Some basic principles of astrological predictions',
    anim: 'mg-ar',
    delay: '.26s',
  },
]
